import environment from '$lib/environment'

export function pdfUrl(id: string, number: string, isClient?: boolean) {
	const route = isClient ? 'pdf_client' : 'pdf'
	//return environment.apiUrl+`/invoices/pdf/${id}/${number}.pdf`;
	return environment.apiUrl + `/invoices/${route}/${id}/${number}.pdf`
}

export function stubUrl(id: string) {
	return `/stub/${id}`
}

export function editInvoiceUrl(id: string) {
	return `/invoices/edit/${id}`
}

export function editEstimateUrl(id: string) {
	return `/estimates/edit/${id}`
}

export function copyEstimateUrl(id: string) {
	return `/estimates/copy/${id}`
}

export function viewEstimateUrl(id: string) {
	return `/estimates/view/${id}`
}

export function pdfEstimateUrl(id: string, number: string, isClient?: boolean) {
	//console.log("pdf: ", environment.apiUrl+`/estimates/pdf/${id}/${number}.pdf`)
	const route = isClient ? 'pdf_client' : 'pdf'
	return environment.apiUrl + `/estimates/${route}/${id}/${number}.pdf`
}

export function copyInvoiceUrl(id: string) {
	return `/invoices/copy/${id}`
}

export function editClientUrl(id: string) {
	return `/clients/edit/${id}`
}

export function editClientShippingLocationUrl(id: string) {
	return `/clientShippingLocations/edit/${id}`
}

export function estimatesUrl(qs?: string) {
	return '/estimates' + (qs ? `?${qs}` : '')
}

export function invoicesUrl(qs?: string) {
	return '/invoices' + (qs ? `?${qs}` : '')
}

export function editItemUrl(id: string) {
	return `/items/edit/${id}`
}

export function copyItemUrl(id: string) {
	return `/items/copy/${id}`
}

export function editTaxUrl(id: string) {
	return `/taxes/edit/${id}`
}

export function editCategoryUrl(id: string) {
	return `/categories/edit/${id}`
}

export function copyCategoryUrl(id: string) {
	return `/categories/copy/${id}`
}

export function editExpenseUrl(id: string) {
	return `/expenses/edit/${id}`
}
export function editExpenseCategoryUrl(id: string) {
	return `/expenses_categories/edit/${id}`
}

export function copyExpenseCategoryUrl(id: string) {
	return `/expenses_categories/copy/${id}`
}



export function buildUrl(path: string, params: any) {
	const query = { ...params }
	let interpolatedPath = path
	for (const [param, value] of Object.entries(params)) {
		const replaced = interpolatedPath.replace(`[${param}]`, value)
		if (replaced !== interpolatedPath) {
			interpolatedPath = replaced
			delete query[param]
		}
	}
	const search = new URLSearchParams(query).toString()
	return `${interpolatedPath}${search ? `?${search}` : ''}`
}

export const PRIVACY_URL = 'https://invoicer.ai/privacy'
export const TERMS_URL = 'https://invoicer.ai/terms'
export const ABOUT_URL = 'https://invoicer.ai/about'
export const CAREERS_URL = 'https://invoicer.ai/careers'
export const FAQ_URL = 'https://help.invoicer.ai/en/collections/2823999-faq'
export const HELP_URL = 'https://help.invoicer.ai/'
export const STORIES_URL = 'https://invoicer.ai/stories'
